import { Controller } from '@hotwired/stimulus';

// Controls ionic modal
export default class extends Controller {
  connect() {
    var modal = document.querySelector('ion-modal');
    if (!modal) return;

    this.modal = modal;
    modal.addEventListener('ionModalDidDismiss', (e) => {
      this.modal.isOpen = false;
    });
  }

  close() {
    document.querySelectorAll('ion-modal.show-modal').forEach((openModal) => {
      openModal.dismiss(null, 'cancel');
      openModal.isOpen = false;
    });
    this.modal.isOpen = false;
  }
}
